import React, { useRef, useState, useEffect, useCallback } from 'react'
import { Modal, message } from 'antd'
import {
	EyeOutlined,
	RotateRightOutlined,
	RotateLeftOutlined,
	ZoomInOutlined,
	ZoomOutOutlined,
} from '@ant-design/icons'
import { getPuzzleCaptcha } from '@http/userCenter'
import RefreshImg from '../images/refresh.png'
import DragBtn from '../images/dragBtn.png'
import DragLoading  from '../images/dragLoading.gif'
import DragError from '../images/dragError.png'
import './index.scss'

function SlidingIndex(props) {
	const { handleCancel, sendCaptcha, msisdn } = props

	const imgWrap = useRef(null)
  const captchaWrap = useRef(null)
  const dragBtnWrap = useRef(null)

	// let dragDrop = false
	// let apartX, apartY

	const [pictureList, setPictureList] = useState('')
	const [pictureLoading, setPictureLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dragStatus, setDragStatus] = useState(1) //滑动块状态： 1正常，2接口请求中，3请求失败,4请求成功
  const [dragData, setDragData] = useState({
    dragDrop:false,
    apartX: 0
  })

	useEffect(() => {
		getPicture()
	}, [])

	// 获取图像
	const getPicture = async () => {
		setPictureLoading(true)
		const { data } = await getPuzzleCaptcha({msisdn})
		setPictureLoading(false)
		if (data.status === 0) {
			setPictureList(data.data)
		} else {
			message.error(data.msg)
			handleCancel()
		}
	}

	// 确定
	const handleOk = () => {
    setDragStatus(2)
    sendCaptcha({
      x: parseInt(captchaWrap.current.offsetLeft)
    },(data)=>{
      if(data.code !== 200){
        // 发送验证码失败
        getPicture()
        dragBtnWrap.current.style.backgroundColor = '#FF464D'
        dragBtnWrap.current.style.borderColor = '#FF464D'
        imgWrap.current.style.backgroundColor = '#FFEAEB'
        imgWrap.current.style.borderColor = '#FF8C90'
        dragBtnWrap.current.firstElementChild.style.width = '14px'
        imgWrap.current.className += " hh_drag_img_animation"
        setDragStatus(3)
        const timeOut = setTimeout(()=>{
          setDragStatus(1)
          dragBtnWrap.current.style.backgroundColor = '#fff'
          dragBtnWrap.current.style.borderColor = '#ccc'
          imgWrap.current.style.width = '45px'
          imgWrap.current.style.backgroundColor = '#EAFFEC'
          imgWrap.current.style.borderColor = '#40AC4B'
          dragBtnWrap.current.firstElementChild.style.width = '24px'
          imgWrap.current.classList.remove("hh_drag_img_animation");
          clearTimeout(timeOut)
        },1000)
      }else{
        setDragStatus(4)
        const timeOut = setTimeout(()=>{
          handleCancel()
          clearTimeout(timeOut)
        },1500)
      }
    })
  }

  // 全局鼠标松开
  const overallMouseup = () => {
    setDragData({
      dragDrop:false,
      apartX: 0
    })
    document.removeEventListener('mouseup',overallMouseup)
    handleOk()
  }

	// 拖拽
	const _mouseDown = (event) => {
    if(!captchaWrap.current) return
		dragData.dragDrop = true
		dragData.apartX = event.pageX - imgWrap.current.offsetLeft // 鼠标在图片中与图片左上角的X轴的距离
    setDragData({...dragData})

    document.addEventListener('mouseup', overallMouseup)

		event.preventDefault()
		event.stopPropagation()
	}
	const _mouseUp = (event) => {
		dragData.dragDrop = false
    setDragData({...dragData})
		event.preventDefault()
		event.stopPropagation()
	}
	const _mouseMove = useCallback((event) => {
		if (!dragData.dragDrop) {
			return
		}
		const leftSkewing = event.pageX - dragData.apartX
    if(leftSkewing < 2){
      return
    }
		if (leftSkewing > 235) {
      imgWrap.current.style.width = 280 + 'px'
			return
		}

		imgWrap.current.style.width = 45 + leftSkewing + 'px'
    captchaWrap.current.style.left = leftSkewing + 'px'

		event.preventDefault()
		event.stopPropagation()
	},[dragData])

	return (
		<Modal
			title="滑动拼图验证"
			visible={true}
			onOk={handleOk}
			onCancel={handleCancel}
			width={320}
			centered
      maskClosable={false}
			footer={null}
		>
			<div className="hh_captcha_modal">
				<div className="hh_captcha_centent">
					{pictureLoading ? (
						<div className="hh_captcha_loading">loading...</div>
					) : (
						<div className="hh_captcha_box">
							<img src={pictureList.image1} alt="" />
							<img
                ref={captchaWrap}
								className="hh_captcha_pos"
								src={pictureList.image2}
								alt=""
							/>
							<img
								className="hh_refresh_captcha"
								src={RefreshImg}
								alt=""
								onClick={getPicture}
							/>
						</div>
					)}
				</div>
        {
          dragStatus === 4 ? <div className="hh_captcha_succeed">
              验证成功
            </div> : <div className="hh_captcha_drag">
            <div
              className="hh_drag_img_bg"
              onMouseUp={_mouseUp}
              onMouseDown={_mouseDown}
              onMouseMove={_mouseMove}
              ref={imgWrap}
            >
              <div className="hh_drag_img" ref={dragBtnWrap}>
                <img src={dragStatus === 1 ? DragBtn : dragStatus === 2 ? DragLoading :  DragError} />
              </div>
            </div>
            请<span className="hh_drag_text">拖动</span>
            左侧滑块将图片还原
          </div>
        }
			</div>
		</Modal>
	)
}

export default SlidingIndex
